"use client"

import { OverlayTrigger, Tooltip } from "react-bootstrap"
import { Calculator } from "lucide-react"

const SwapForm = ({
  blockChainSellSelected,
  blockChainBuySelected,
  tokenSellSelected,
  tokenBuySelected,
  amount,
  setAmount,
  setBlockChainSelectionContext,
  setSelectBlockchain,
  setTokenSelectionContext,
  setSelectToken,
  setBlockChainSearchKeyword,
  setTokenSearchKeyword,
  setActionButtonLabel,
  setWidgetState,
  setErrorMessage,
  amountError,
  receivingAmount = 0,
  handleCalculate,
}) => {

  return (
    <div>
      {/* You pay crypto Section */}
      <div className="rango-you--sell" id="tour-token-sell">
        <div className="rango-flex rango-flex--between mb-3">
          <div className="text-16 font-medium">You pay crypto</div>
          <div className="rango-sell-balance">Balance: {tokenSellSelected.balance} {tokenSellSelected.symbol}</div>
        </div>
        <div className="rango-filter--group items-start">
          <div>
            <div className="text-12" style={{ marginBottom: "5px", lineHeight: '1.2' }}>Select Network</div>
            <div
              className="rango-select--item rango-select--blockchain-sell"
              onClick={() => {
                setBlockChainSelectionContext("sell")
                setBlockChainSearchKeyword("")
                setSelectBlockchain(true)
              }}
            >
              <div className="rango-select--icon">
                <img alt={blockChainSellSelected.name} src={blockChainSellSelected.image || "/placeholder.svg"} />
              </div>
              <div className="rango-select--option">{blockChainSellSelected.name}</div>
              <div className="rango-select--icon">
                <svg fill="currentColor" width="13px" height="13px" viewBox="0 0 32 32">
                  <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <div className="text-12" style={{ marginBottom: "5px" }}>Select token</div>
            <div
              className="rango-select--item"
              onClick={() => {
                setTokenSelectionContext("sell")
                setTokenSearchKeyword("")
                setSelectToken(true)
              }}
            >
              <div className="rango-select--icon">
                {tokenSellSelected.image && (
                  <img src={tokenSellSelected.image || "/placeholder.svg"} alt={tokenSellSelected.symbol} />
                )}
              </div>
              <div className="rango-select--option">{tokenSellSelected.symbol}</div>
              <div className="rango-select--icon">
                <svg fill="currentColor" width="13px" height="13px" viewBox="0 0 32 32">
                  <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <div className="flex gap-2">
              <div className="text-12" style={{ marginBottom: "5px" }}>
                Swap amount
              </div>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="coin-image-tooltip"> Select the value which should be less than or equal to balance</Tooltip>}
              >
                <svg width="16px" height="16px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" fill-rule="evenodd" d="M8 16A8 8 0 108 0a8 8 0 000 16zm0-9a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 018 7zm0-3a1 1 0 000 2h.007a1 1 0 000-2H8z" clip-rule="evenodd" /></svg>
              </OverlayTrigger>

            </div>
            <input
              onChange={(event) => {
                setAmount(event.target.value)
                setActionButtonLabel("Find Routes")
                setWidgetState("SelectSwapPair")
                if (typeof setErrorMessage === "function") {
                  setErrorMessage("")
                }
              }}
              id="tour-amount-input"
              type="number"
              className={`rango-select--item ${amountError ? 'border-danger' : ''}`}
              placeholder="0"
              value={amount || ""}
            />
            {amountError && (
              <div className="text-danger text-12 mt-1 fw-medium" style={{ color: '#dc3545' }}>
                {amountError}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="rango-divider--icon"></div>

      {/* You Receive Crypto Section */}
      <div className="rango-you--receive" id="tour-token-buy">
        <div className="rango-flex rango-flex--between mb-3">
          <div className="text-16 font-medium">You Receive Crypto</div>
          <div className="rango-sell-balance">
            {receivingAmount > 0 && tokenBuySelected?.price?.price
              ? `~ equivalent in $${(parseFloat(receivingAmount) * parseFloat(tokenBuySelected.price.price)).toFixed(2)} USD`
              : ""}
          </div>
        </div>
        <div className="rango-filter--group items-end">
          <div>
            <div className="text-12" style={{ marginBottom: "5px" }}>Select Network</div>
            <div
              className="rango-select--item"
              onClick={() => {
                setBlockChainSelectionContext("buy")
                setBlockChainSearchKeyword("")
                setSelectBlockchain(true)
              }}
            >
              <div className="rango-select--icon">
                <img src={blockChainBuySelected.image || "/placeholder.svg"} alt={blockChainBuySelected.name} />
              </div>
              <div className="rango-select--option">{blockChainBuySelected.name}</div>
              <div className="rango-select--icon">
                <svg fill="currentColor" width="13px" height="13px" viewBox="0 0 32 32">
                  <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <div className="text-12" style={{ marginBottom: "5px" }}>Select token</div>
            <div
              className="rango-select--item"
              onClick={() => {
                setTokenSelectionContext("buy")
                setTokenSearchKeyword("")
                setSelectToken(true)
              }}
            >
              <div className="rango-select--icon">
                {tokenBuySelected.image && (
                  <img src={tokenBuySelected.image || "/placeholder.svg"} alt={tokenBuySelected.symbol} />
                )}
              </div>
              <div className="rango-select--option">{tokenBuySelected.symbol}</div>
              <div className="rango-select--icon">
                <svg fill="currentColor" width="13px" height="13px" viewBox="0 0 32 32">
                  <path d="M0.256 8.606c0-0.269 0.106-0.544 0.313-0.75 0.412-0.412 1.087-0.412 1.5 0l14.119 14.119 13.913-13.912c0.413-0.412 1.087-0.412 1.5 0s0.413 1.088 0 1.5l-14.663 14.669c-0.413 0.413-1.088 0.413-1.5 0l-14.869-14.869c-0.213-0.213-0.313-0.481-0.313-0.756z" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <div className="flex gap-2">
              <div className="text-12" style={{ marginBottom: "5px" }}>
                Calculate receive amount
              </div>
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="receive-amount-tooltip">Approximate received amount excluding gas fees</Tooltip>}
              >
                <svg width="16px" height="16px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="none"><path fill="#000000" fill-rule="evenodd" d="M8 16A8 8 0 108 0a8 8 0 000 16zm0-9a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 018 7zm0-3a1 1 0 000 2h.007a1 1 0 000-2H8z" clip-rule="evenodd" /></svg>
              </OverlayTrigger>
            </div>
            <div
              className="rango-select--item"
              style={{ display: "flex", alignItems: "center", justifyContent: "space-between", opacity: 0.8 }}
            >
              <span>{receivingAmount || 0}</span>
              {/* <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="receive-amount-tooltip">Calculate Receive amount</Tooltip>}
              >
                <div className="btn btn-primary w-auto p-1 rounded-circle">
                  <Calculator
                    size={24}
                    strokeWidth={1.5}
                    className="cursor-pointer hover:text-primary transition-colors text-gray-900"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (typeof handleCalculate === 'function') {
                        handleCalculate();
                      }
                    }}
                    style={{ cursor: 'pointer' }}
                  />
                </div>
              </OverlayTrigger> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SwapForm
